import { render } from "./Activities.vue?vue&type=template&id=5e3b896f"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"
script.render = render

export default script